import get from "lodash/get"
import axios from "axios"
import { getTokenAction } from "actions-lib/getToken"
import { userType } from "constants-lib/authentication"
import { urls } from "utils-lib/builds"
import {
  SUBMIT_SERVICE_REQUEST_FORM_PENDING,
  SUBMIT_SERVICE_REQUEST_FORM_FAILED,
  SUBMIT_SERVICE_REQUEST_FORM_FULFILLED,
} from "constants-lib/actionTypes"

export const pendingAC = () => ({
  type: SUBMIT_SERVICE_REQUEST_FORM_PENDING,
})

export const failedAC = (data) => ({
  type: SUBMIT_SERVICE_REQUEST_FORM_FAILED,
  payload: data,
})

export const fulfilledAC = (data) => ({
  type: SUBMIT_SERVICE_REQUEST_FORM_FULFILLED,
  payload: data,
})

/**
 * Submits a service request form, handling both pickup and delivery options with appropriate API calls.
 * @param {Object} data - The form data to be submitted.
 * @param {boolean} [isPickup=true] - Flag indicating if the service request is for pickup (true) or delivery (false).
 * @param {string} userId - The user's unique identifier.
 * @param {string} language - The language preference for the service request.
 * @returns {Function} when dispatched, performs the API call and dispatches actions based on the response.
 */
export const submitServiceRequestForm =
  (data, isPickup = true, userId, language) =>
  (dispatch, getState) => {
    const api = `USER_REQUEST_SERVICE`
    const url = urls.url[api]

    dispatch(pendingAC())

    if (isPickup) {
      const { userAccount } = getState()
      const { userState, userDetails } = userAccount
      const postOptions = {
        method: `post`,
        url,
        data,
      }

      if (userState === userType.LOGGED_IN) {
        return getTokenAction(dispatch, getState).then((token) => {
          postOptions.headers = {
            oktaToken: token.accessToken,
            [urls.okta.tokenFieldKey]: token.accessToken,
            apiKey: get(urls, `apiKey.USER[${api}]`, ``),
          }
          postOptions.params = {
            userId: userDetails.userId,
          }

          return axios(postOptions)
            .then((response) => {
              dispatch(fulfilledAC(response.data))
              return data
            })
            .catch((e) => {
              console.error(e)
              dispatch(failedAC(e.response.status))
            })
        })
      }
      postOptions.headers = {
        apiKey: get(urls, `apiKey.GUEST[${api}]`, ``),
      }

      return axios(postOptions)
        .then((response) => {
          dispatch(fulfilledAC(response.data))
          return data
        })
        .catch((error) => {
          dispatch(failedAC(error.response.status))
          console.error(error)
        })
    }
    const finalUrl = `${url}?userId=${userId}&lang=${language}`
    const headers = {
      apiKey: get(urls, `apiKey.GUEST[${api}]`, ``),
    }

    return axios({
      method: `post`,
      url: finalUrl,
      data,
      headers,
    })
      .then((response) => {
        dispatch(fulfilledAC(response.data))
        return response
      })
      .catch((e) => {
        console.error(e)
        dispatch(failedAC(e.response.status))
        return e.response
      })
  }
